/* eslint-disable */
import Vue from 'vue';
import moment from 'moment';
import VueMoment from 'vue-moment';
import HighchartsVue from 'highcharts-vue';
import VueTheMask from 'vue-the-mask';
import html2canvas from 'html2canvas';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import App from './App';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import DateFilter from './filters/date';
import DecimalFilter from './filters/decimal';
import '@/plugins/keycloak';

window.html2canvas = html2canvas;

Vue.config.productionTip = false;
Vue.filter('date', DateFilter);
Vue.filter('decimal', DecimalFilter);
moment.locale('pt-br');
Vue.use(VueMoment, { moment });
Vue.use(HighchartsVue);
Vue.use(VueTheMask);

let instance;

Vue.$keycloak.init({
  onLoad: 'check-sso',
  checkLoginIframe: true,
})
  .then(() => {
    instance = new Vue({
      router,
      store,
      vuetify,
      render(h) {
        return h(App);
      },
    }).$mount('#app');
  }).then(() => {
    // Vincula e-mail para identificar o usuário nos erros reportados no Sentry
    // Tempo de espera para garantir que o e-mail já esteja carregado no estado
    /* setTimeout(() => {
      if (instance.$store.state.auth.usuario) {
        Sentry.setUser({ email: instance.$store.state.auth.usuario.email });
      }
    }, 2000); */
  });

// Configura o sistema para que o Sentry monitore os erros e transações efetuadas
/* Sentry.init({
  Vue,
  dsn: 'https://59039833ccf544fea8fcaa014f4e5e2f@o4504038305955840.ingest.sentry.io/4504038313361408',
  environment: process.env.NODE_ENV,
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: [
        'localhost',
        'teste-desenvolva.devel.sti.ufc.br/',
        'desenvolva.devel.sti.ufc.br/',
        'appdesenvolva.ufc.br/',
        /^\//,
      ],
    }),
  ],
  tracesSampleRate: 0.2,
}); */
